import type { Lesson } from '../schema.js';

// Crazy Eights lessons: explain + quiz only. The facts match the game as built
// (packages/game-engine/src/crazy-eights/play.ts): 2 to 4 players, five cards each (seven when two play), play a card
// of the same suit or the same number as the top of the pile, an eight is wild and you name the suit, draw one card
// when you cannot play, the first to empty their hand wins and scores the cards left in the other hands (an eight is
// 50, a jack, queen or king is 10, an ace is 1, anything else its number), and a game goes to 100. These rules are
// recalled, not checked against a rulebook, and a player should confirm them.
export const CRAZY_EIGHTS_LESSONS: Lesson[] = [
  {
    id: 'crazy-eights-matching',
    slug: 'crazy-eights-matching-and-eights',
    title: 'Crazy Eights: matching and eights',
    audienceLevel: 'beginner',
    concepts: ['crazy-eights'],
    steps: [
      {
        kind: 'explain',
        title: 'Match the suit or the number',
        body: 'In Crazy Eights everyone gets five cards, or seven when only two people play, and one card is turned up to start the pile. On your turn you play a card that matches the top of the pile in suit or in number, like a 6 of hearts on a 6 of clubs, or a 9 of hearts on a 2 of hearts. An eight is wild: you can play it on anything, and then you name the suit that comes next. If you cannot play, you draw one card, and you play it if it fits. The first player to get rid of every card wins the hand.',
        narration: 'Match the suit or the number. An eight is wild, and you name the next suit.',
      },
      {
        kind: 'quiz',
        title: 'Matching',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'The top card is the 6 of clubs. Which card can you play?',
            choices: ['The 6 of hearts', 'The 9 of hearts', 'The king of spades'],
            correct: 0,
          },
          {
            prompt: 'You play an eight. What else do you do?',
            choices: ['Name the suit for the next card', 'Draw two cards', 'Take another turn'],
            correct: 0,
          },
          {
            prompt: 'You cannot play any card. What do you do?',
            choices: ['Draw one card', 'Draw three cards', 'Pass without drawing'],
            correct: 0,
          },
        ],
      },
    ],
  },
  {
    id: 'crazy-eights-scoring',
    slug: 'crazy-eights-scoring-a-game',
    title: 'Crazy Eights: scoring a game',
    audienceLevel: 'beginner',
    concepts: ['crazy-eights'],
    steps: [
      {
        kind: 'explain',
        title: 'Points for going out',
        body: 'When someone plays their last card, they win the hand and score the cards still in the other players\' hands. An eight is worth 50 points, a jack, queen or king is worth 10, an ace is worth 1, and every other card is worth its number. So it is a good idea to play your eights before the hand ends. The points add up over several hands, and the first player to reach 100 wins the game.',
        narration: 'Going out scores the cards left in the other hands. Eights are worth fifty, so play them early.',
      },
      {
        kind: 'quiz',
        title: 'Scoring',
        body: 'Time for a quick check!',
        questions: [
          {
            prompt: 'Which card is worth the most points when it is left in a hand?',
            choices: ['An eight', 'A king', 'An ace'],
            correct: 0,
          },
          {
            prompt: 'You go out. An opponent still holds a queen and a 4. How many points do you score from that hand?',
            choices: ['14', '10', '4'],
            correct: 0,
          },
          {
            prompt: 'How many points does a player need to win the game?',
            choices: ['100', '50', '500'],
            correct: 0,
          },
        ],
      },
    ],
  },
];
